//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import starYellow from '@/assets/icons/starYellow.png'
import starWhite from '@/assets/icons/starWhite.png'
export default {
  props: ['data'],
  // data: {
  //   value: number 0-1
  // }
  data () {
    return {
      sy: starYellow,
      sw: starWhite
    }
  },
  computed: {
    syWidth: function () {
      return {
        'width': (0.2 * this.data.value) + 'rem' // 0.2是星星有宽度。
      }
    }
  },
  components: {}
}



// WEBPACK FOOTER //
// ./src/components/clinic/starValue.vue